const shared = {
  home: 'الرئيسية',
  language: 'EN',
  admins: 'المديرين',
  lookups: 'العمليات',
  BranchesManagement: 'إدارة الفروع',
  bookings: 'الحجوزات',
  Branches: 'الفروع',
  serviceProviderCategories: 'فئات مقدمي الخدمات',
  serviceProviders: 'مقدمي الخدمات',
  publishRequests: 'طلبات النشر',
  specialties: 'التخصصات',
  services: 'الخدمات',
  lookupsRequests: "طلبات اضافة خدمات",
  logout: 'تسجيل الخروج',
  lang: 'English',
  back: 'الرجوع',
  noSearch: 'عفوا، لم يتم العثور على نتائج بحثك!',
  noServicesAddedyet: 'عفوا، لم يتم اضافة خدمات بعد',
  noSpecialtiesOnCategoryyet: 'عفوا، لا يحتوي هذا التصنيف على أي تخصصات',
  noEmployeesAddedyet: 'عفوا، لم يتم اضافة موظفين بعد',
  noData: 'لا توجد بيانات حتى الان',
  noDataToShow: 'لا توجد بيانات',
  noEmployeesAdded: 'لا يوجد موظفين مضافين حتى الان',
  noReviewsAdded: 'لا يوجد تقييمات مضافة حتى الان',
  employees: 'الموظفين',
  customers: 'العملاء',
  noServicesAdded: 'لا يوجد خدمات مضافة حتى الان',
  actions: 'أفعال',
  edit: 'تعديل',
  add: 'اضافة',
  view: 'تفاصيل',
  delete: 'حذف',
  save: 'حفظ',
  saveAndProcced: 'حفظ و متابعة',
  done: 'تم',
  cancel: 'الغاء',
  submit: 'أرسل',
  previous: 'السابق',
  filter: 'تصفية',
  confirm: 'تأكيد',
  copy: 'نسخ',
  copied: 'تم النسخ',
  procced:'متابعة',
  lists: {
    enTitle: 'الاسم بالانجليزية',
    arTitle: 'الاسم بالعربية',
    enName: 'الاسم بالانجليزية',
    arName: 'الاسم بالعربية',
    name: 'الاسم',
    email: 'البريد الالكتروني',
    phone: 'رقم الهاتف',
    image: 'الصورة',
    categories: 'الفئات',
    status: 'الحالة',
    category: 'الفئة',
    branchName: 'اسم الفرع',
    location: 'عنوان',
    rating: 'التقييم',
    providerName: 'اسم مقدم الخدمة',
    appointmentId: 'رقم الحجز',
    customerName: 'اسم العميل',
    date: 'التاريخ',
    transactionType:'نوع معاملة الدفع',
    paidAmount:'المبلغ المدفوع',
    settlementAmount:'مبلغ التسوية',
    settlementEquation:'معادلة التسوية',
    mimarCommission:"عمولة ميمار",
  },
  filesAccepted: 'الحجم الأقصى: 2MB، الصيغات المقبولة: jpg، jpeg، png، و bmp',
  acceptedFormatLabel: 'الصيغات المقبولة',
  noOptions: 'لا يوجد خيارات',
  generalErrMsg: 'لقد حدث خطأ ما!',
  days: {
    sat: 'السبت',
    sun: 'الاحد',
    mon: 'الاثنين',
    tus: 'الثلاثاء',
    wed: 'الاربعاء',
    thurs: 'الخميس',
    fri: 'الجمعة',
  },
  closed: 'مغلق',
  polygonHint: 'لتأكيد منطقتك، انقر داخل المضلع بعد الانتهاء',
  ResetPolygon: 'إعادة تعيين المضلع',
  settings: 'الإعدادات',
  notifications:'الإشعارات',
  admin:'مسؤول',
  superAdmin: ' مسؤول رئيسي',
  financial: 'المالية',
  transactions: 'معاملات الدفع',
  settlements: " التسويات والمبالغ المستحقة",
  mimarProfit: "أرباح ميمار",
  noInternetConnectionMsg:"لا يوجد اتصال بالإنترنت, حاول مرة آخرى",
  noMatchedData:"لا توجد بيانات مطابقة"
};

export default shared;
